export const CHECKOUT_URL = 'https://reto-30-dias-fit.impultienda.ar/'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/4eE5GgRoma3qA6zU5WdWY2/hf_20260809_061703_b3617452-81d1-4e5e-8ae0-8a75af995883.png'

export type Pain = {
  title: string
  text: string
}

export const pains: Pain[] = [
  {
    title: 'Mañana',
    text: 'Mirándote al espejo con el abdomen inflamado y sintiéndote incómoda en tu propio cuerpo.',
  },
  {
    title: 'Cuerpo que no responde',
    text: 'Sin importar cuánto te esfuerces — y no sabés que el cortisol alto es el saboteador silencioso.',
  },
  {
    title: 'Dietas extremas',
    text: 'Te dejan con hambre, ansiedad y efecto rebote peor que antes.',
  },
  {
    title: 'Rutinas que abandonás',
    text: 'A los 10 días porque son aburridas, largas y sin resultados visibles.',
  },
  {
    title: 'Ansiedad por el dulce',
    text: 'A las 4 de la tarde, destruyendo todo tu avance del día.',
  },
  {
    title: 'Sin tiempo para el gimnasio',
    text: 'Y sin saber qué hacer en casa de forma efectiva.',
  },
  {
    title: 'Fin de semana',
    text: 'El lunes volvés a empezar el mismo ciclo de frustración.',
  },
]

export type Tomo = {
  number: string
  tag: string
  title: string
  text: string
}

export const tomos: Tomo[] = [
  {
    number: 'TOMO 1',
    tag: 'Detox',
    title: 'DETOX & CORTISOL RESET',
    text: 'Protocolo de 7 días para desinflamarte, resetear el cortisol y arrancar con energía. Hidratación, sueño y rutina matutina incluidos.',
  },
  {
    number: 'TOMO 2',
    tag: 'Gym',
    title: 'EL TEMPLO — SISTEMA GYM 360',
    text: 'Sistema completo de entrenamiento en gym. Anatomía, biomecánica, rutinas de 3 y 6 días, 3 niveles y plan de 12 semanas.',
  },
  {
    number: 'TOMO 3',
    tag: 'Casa',
    title: 'EL REFUGIO — SISTEMA CASA 360',
    text: 'Todo el poder del gym, en tu casa. Ejercicios sin equipamiento, progresiones reales y rutinas que dan resultados visibles.',
  },
  {
    number: 'TOMO 4',
    tag: 'Nutrición',
    title: 'NUTRICIÓN ANTI-CORTISOL',
    text: 'Top 30 alimentos antiinflamatorios, plato perfecto, alimentación según ciclo menstrual y plan nutricional de 4 semanas.',
  },
  {
    number: 'TOMO 5',
    tag: 'Ayuno',
    title: 'AYUNO INTERMITENTE & CONTROL MENTAL',
    text: 'Protocolos 12:12 → 16:8, cómo romper el ayuno, manejo de ansiedad, hambre emocional y plan de 8 semanas.',
  },
  {
    number: 'TOMO 6',
    tag: 'Batch Cooking',
    title: 'BATCH COOKING ECONÓMICO',
    text: '25 combinaciones de comidas, menú semanal, lista de compras maestra y 15 recetas completas. Cocinás 1 vez, comés bien toda la semana.',
  },
]

export const tomoIncludes: string[] = [
  'Contenido 100% listo — abrís el PDF y arrancás hoy',
  'Niveles: Principiante / Intermedio / Avanzado',
  'Ejercicios con biomecánica exacta y correcciones',
  'Checklists, planillas de seguimiento y progresión',
  'Diseñado para la mujer real con poco tiempo',
]

export type Bonus = {
  label: string
  title: string
  text: string
  price: string
  badge: string
  isVideo?: boolean
}

export const bonuses: Bonus[] = [
  {
    label: 'BONO 1',
    title: 'RECETARIO DULCE FIT ANTI-ANSIEDAD',
    text: '30+ recetas de postres, meriendas y desayunos dulces que eliminan la ansiedad sin romper tu progreso. Incluye recetas de 5 minutos para las emergencias reales de las 4 de la tarde.',
    price: '$18.000',
    badge: 'GRATIS',
  },
  {
    label: 'BONO 2',
    title: 'GUÍA DE SUPLEMENTACIÓN INTELIGENTE',
    text: 'Qué suplementos realmente valen la pena, cuáles son solo marketing caro y cómo combinarlos para acelerar la pérdida de grasa y la tonificación sin tirar dinero.',
    price: '$15.000',
    badge: 'GRATIS',
  },
  {
    label: 'VIDEO MASTERCLASS',
    title: 'TÉCNICA PERFECTA DE GLÚTEOS — 2 VIDEOS EXPLICATIVOS',
    text: 'Videos detallados para que domines la activación correcta del glúteo, nunca sientas dolor de espalda al entrenar y maximices cada repetición desde el primer día.',
    price: '$12.000',
    badge: 'INCLUIDO',
    isVideo: true,
  },
]

export type CostRow = {
  without: string
  cost: string
}

export const costRows: CostRow[] = [
  { without: 'Dietas sin estructura ni ciencia', cost: 'Efecto rebote — tiempo y dinero perdido' },
  { without: 'Ejercicios sin progresión ni técnica', cost: 'Sin resultados visibles — abandono garantizado' },
  { without: 'Cortisol alto sin saberlo', cost: 'Grasa acumulada en cintura que no se va' },
  { without: 'Ansiedad por el dulce sin herramientas', cost: 'Culpa crónica — relación tóxica con la comida' },
  { without: 'Sin batch cooking ni planificación', cost: 'Comida procesada por falta de tiempo' },
  { without: 'Buscando rutinas en Instagram', cost: 'Confusión — el mismo ciclo el próximo mes' },
  { without: 'Sin guía de ayuno intermitente', cost: 'Lo hacés mal y empeoran los síntomas' },
  { without: 'Fin de semana buscando en internet', cost: 'El mismo ciclo — el próximo año' },
]

export type Testimonial = {
  initials: string
  quote: string
  name: string
  city: string
}

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'LM',
    quote:
      'Bajé 4 kilos de pura inflamación en la primera semana. El enfoque en el cortisol cambió todo. Mi energía es completamente otra.',
    name: 'Lucía M.',
    city: 'Buenos Aires',
  },
  {
    initials: 'CP',
    quote:
      'Los ejercicios en casa son cortos pero efectivos. Mis glúteos están más firmes que nunca en solo 20 días. ¡Y sin gimnasio!',
    name: 'Carla P.',
    city: 'Santiago',
  },
  {
    initials: 'VR',
    quote:
      'El batch cooking me cambió la vida. Preparo todo el domingo y como bien toda la semana sin esfuerzo. Vale cada peso.',
    name: 'Valentina R.',
    city: 'Rosario',
  },
]

export const testimonials: Testimonial[] = [
  {
    initials: 'CR',
    quote:
      'El Tomo de Nutrición Anti-Cortisol me hizo entender por qué acumulaba grasa en la cintura aunque comía sano. En 3 semanas cambió todo.',
    name: 'Cecilia R.',
    city: 'Mendoza',
  },
  {
    initials: 'RM',
    quote:
      'Con el Recetario Dulce Fit corté la ansiedad de las 4 de la tarde. Eso solo ya valió la inversión entera. Los postres están buenísimos.',
    name: 'Romina M.',
    city: 'Buenos Aires',
  },
  {
    initials: 'SC',
    quote:
      'El plan de glúteos en casa funciona. Sin gym, sin equipamiento. A los 15 días noté cambios en el espejo que antes tardaban meses.',
    name: 'Sofía C.',
    city: 'La Plata',
  },
  {
    initials: 'VL',
    quote:
      'El batch cooking me cambió la vida. Preparo el domingo y no vuelvo a pensar en comida hasta el próximo. Bajé 3 kilos sin hacer dieta.',
    name: 'Valeria L.',
    city: 'Rosario',
  },
  {
    initials: 'PA',
    quote:
      'El Tomo de Ayuno Intermitente me enseñó a romperlo bien. Antes lo hacía mal y me daba más hambre. Ahora es parte natural de mi día.',
    name: 'Paula A.',
    city: 'Neuquén',
  },
  {
    initials: 'DM',
    quote:
      'Los videos de técnica de glúteos son un antes y un después. Nunca más me dolió la espalda al hacer sentadillas. Mis glúteos sienten cada rep.',
    name: 'Daniela M.',
    city: 'Córdoba',
  },
]

export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Sirve si nunca hice ejercicio antes?',
    a: 'Sí. Cada rutina tiene tres niveles: Principiante, Intermedio y Avanzado. Arrancás desde donde estás hoy, con progresiones claras semana a semana y correcciones de técnica para que no te lastimes.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Apenas se confirma el pago recibís un email con el acceso — en menos de 5 minutos. Descargás los 6 tomos en PDF, los bonos y los videos. Es tuyo para siempre, en cualquier dispositivo.',
  },
  {
    q: '¿Funciona si solo puedo entrenar en casa?',
    a: 'Totalmente. El Tomo 3 "El Refugio — Sistema Casa 360" está diseñado sin equipamiento, con progresiones reales para que sigas avanzando sin tocar una máquina. Miles de mujeres lo hacen así.',
  },
  {
    q: '¿Qué lo diferencia de buscar rutinas en YouTube o Instagram?',
    a: 'Ahí encontrás ejercicios sueltos, sin orden, sin progresión y sin nutrición. Acá tenés un sistema completo: detox, entrenamiento, alimentación anti-cortisol, ayuno y mentalidad — todo secuenciado día por día.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para usar el material completo. Si no es exactamente lo que esperabas, te devolvemos el 100% sin formularios, sin explicaciones y sin drama. Nuestra tasa de devoluciones es menor al 1%.',
  },
]
